import script from "./GlobusSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusSelector.vue?vue&type=script&setup=true&lang=js"

import "./GlobusSelector.vue?vue&type=style&index=0&id=33e4ccb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e4ccb2"]])

export default __exports__